import { T, always, cond, or, propEq } from 'ramda';
import React, { FC } from 'react';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import BackAndNextNav, { IBackAndNextNavProps } from '@ui/molecules/BackAndNextNav';

import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import { commonLabels } from '@utils/button';

import { IInsuranceWaivable } from '@data/insurance';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import { dataConstants } from './MembershipInsuranceStatusStep.data';

export interface IMembershipInsuranceStatusStepPageContent {
	inNetworkHeader: string;
	inNetworkCoveredDescription: string;
	inNetworkDescription: string;
	outNetworkHeader: string;
	outNetworkDescription: string;
}

interface IMembershipInsuranceStatusStepProps extends IFlowStepComponentProps {
	pageContent: IMembershipInsuranceStatusStepPageContent;
	serviceWaivable: IInsuranceWaivable;
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const FullWidthBackAndNext = fullWidth<IBackAndNextNavProps>(BackAndNextNav);
const SpacedHeading = spaced(HeadingText);

const MembershipInsuranceStatusStep: FC<IMembershipInsuranceStatusStepProps> = ({
	pageContent,
	handleFormSubmission = () => {},
	handleNavBack = () => {},
	serviceWaivable,
	stepKey,
}) => {
	const {
		inNetworkHeader,
		inNetworkCoveredDescription,
		inNetworkDescription,
		outNetworkHeader,
		outNetworkDescription,
	} = pageContent;

	const getHeader = () => {
		return cond<IInsuranceWaivable, boolean, string>([
			[
				(waivable: IInsuranceWaivable) =>
					or(propEq('isWaivable', true, waivable), propEq('inNetwork', true, waivable)),
				always(inNetworkHeader),
			],
			[T, always(outNetworkHeader)],
		])(serviceWaivable);
	};

	const getDescription = () => {
		return cond<IInsuranceWaivable, boolean, string>([
			[propEq('isWaivable', true), always(inNetworkCoveredDescription)],
			[propEq('inNetwork', true), always(inNetworkDescription)],
			[T, always(outNetworkDescription)],
		])(serviceWaivable);
	};

	const onSubmit = () => {
		const data = {
			[dataConstants.isWaivable]: serviceWaivable.isWaivable,
			[dataConstants.exemptBy]: serviceWaivable.exemptBy,
		};
		handleFormSubmission(data, stepKey);
	};

	return (
		<FullWidthColumn>
			<SpacedHeading marginBottom="sm">{getHeader()}</SpacedHeading>
			<BasicText>{getDescription()}</BasicText>
			<FullWidthBackAndNext
				backOnClick={() => handleNavBack(stepKey)}
				nextOnClick={onSubmit}
				submitLabel={commonLabels.next}
				marginTop="lgxl"
			/>
		</FullWidthColumn>
	);
};

export default MembershipInsuranceStatusStep;
